module.exports = __webpack_public_path__ + "media/images/completed-5efc10da9587c8cfb4ebf8f48ce8e05a.png";